export const getAgentHubAffiliationOptions = (
  region: string,
): Array<App.AgentHubAUAgencyAffiliations | App.AgentHubNZAgencyAffiliations> => {
  if (region === 'NZ') return AGENT_HUB_NZ_AFFILIATION_OPTIONS
  return AGENT_HUB_AU_AFFILIATION_OPTIONS
}

export const AGENT_HUB_AU_AFFILIATION_OPTIONS: Array<App.AgentHubAUAgencyAffiliations> = [
  '1000 Mile Travel Group',
  'ATAC',
  'CT Partners',
  'Express Travel Group',
  'FBI Travel',
  'FC Independent',
  'Flight Centre Brand',
  'Flight Centre Business Travel',
  'Goldman Travel Corporation',
  'Helloworld',
  'Helloworld Associate',
  'Helloworld Branded',
  'Helloworld Business Travel',
  'House of Travel',
  'Independent (no affiliation)',
  'Independent Travel Group (part of ETG)',
  'italktravel & cruise',
  'itravel Australia Group',
  'Link',
  'Magellan Travel Group',
  'MTA Travel',
  'My Travel Group',
  'Platinum Travel Management',
  'Pulse Travel',
  'Savenio',
  'Select Travel Service',
  'Smartflyer Australia Pty Ltd',
  'Travel Associates',
  'Travel at 60',
  'Travel Partners',
  'Travellers Choice Limited',
  'TravelManagers Australia',
  'Other (please specify)',
]
export const AGENT_HUB_NZ_AFFILIATION_OPTIONS: Array<App.AgentHubNZAgencyAffiliations> = [
  'Accent on Travel',
  'APX Travel Management',
  'BonVoyage Cruises & Travel',
  'China Travel Service',
  'Excel Travel',
  'Express Travel Group',
  'First Travel Group',
  'Flight Centre NZ',
  'Helloworld NZ',
  'House of Travel',
  'Independent no Affiliation',
  'Mondo Travel',
  'Orbit Travel',
  'Our Vacation Centre',
  'Our World',
  'Planet Earth Travel',
  'Quay Travel',
  'Travel Associates NZ',
  'Travel Managers NZ',
  'World Travellers',
  'Worldwide Holidays',
  'You Travel and Cruise',
]

export const AGENT_HUB_DEFAULT_PHONE_NUMBER_PREFIX: Record<App.AgentHubAvailableRegions, string> = {
  AU: '+61',
  CA: '+1',
  CN: '+86',
  FR: '+33',
  DE: '+49',
  IN: '+91',
  ID: '+62',
  IE: '+353',
  IL: '+972',
  IT: '+39',
  JP: '+81',
  KR: '+82',
  MO: '+853',
  MY: '+60',
  NL: '+31',
  NZ: '+64',
  PH: '+63',
  QA: '+974',
  RU: '+7',
  SA: '+966',
  SG: '+65',
  ZA: '+27',
  ES: '+34',
  TW: '+886',
  TH: '+66',
  AE: '+971',
  GB: '+44',
  US: '+1',
  VN: '+84',
}
